import { mapResponse } from './transform';
import axios from 'axios';

export default {
  async transactionHistory(context) {
    try {
      const { data } = await this.$axios.get('/smartphone/purchase-histories?orderBy=createdAt&descending=true');
      const response = data.data;
      context.commit('updateTransactionHistory', response);
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  async getPolicyList(context) {
    try {
      const codeCountry = await context.rootGetters['general/getCountryCode'];
      let APIPath = '/smartphone/policies';
      if (codeCountry === 'VN') {
        // New Endpoint not support limit
        APIPath = `/policies/list?productCategory=smartphone&country=${codeCountry}`;
      } else {
        APIPath = APIPath + '?limit=100';
      }
      const { data } = await this.$axios.get(`${process.env.API_BASE_URL}${APIPath}`);
      const response = data.data;
      context.commit('updatePolicyList', response);
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  async getListClaim(context, { page }) {
    try {
      const query = `orderBy=updatedAt&&limit=7&&page=${page}`;
      const { data } = await this.$axios.get(`/smartphone/claims?${query}`);
      const response = data;
      const claims = context.getters['getClaims'];
      if (claims && Object.keys(claims).length > 0) {
        response.data = claims.data.concat(response.data);
        context.commit('updateClaims', response);
      } else {
        context.commit('updateClaims', response);
      }
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  },
  async getSmartphone(context, { query, type }) {
    try {
      const { data } = await axios.get(`${process.env.API_BASE_URL}/products/smartphone/${query}`);
      const response = data.data;
      if (type === 'brand') {
        context.commit('updateSmartphoneBrand', response);
      } else if (type === 'model') {
        context.commit('updateSmartphoneModel', response);
      }
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getProductList(context, { payload }) {
    try {
      const { data } = await axios.post(`${process.env.API_BASE_URL}/products/smartphone`, payload);
      const response = data.data;
      context.commit('setListProduct', mapResponse({ type: 'productList', response }));
      // context.commit('setListProduct', response);
      // return response;
      return mapResponse({ type: 'productList', response });
      // return response;
    } catch (error) {
      return error;
    }
  },
  // * Update Claim Smartphone MOMO Screen Crack confirm excessFee
  async updateClaimExcessFee(context, { number, status }) {
    try {
      const { data } = await this.$axios.put(`${process.env.API_BASE_URL}/smartphone/v1/claims/${number}`, { status });
      return data;
    } catch (error) {
      throw error;
    }
  }
};
